/**
 * Converts hex color to RGB values
 */
function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

/**
 * Calculates the relative luminance of a color
 * Based on WCAG 2.1 guidelines
 */
function getLuminance(r: number, g: number, b: number): number {
    const [rs, gs, bs] = [r, g, b].map(c => {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
}

/**
 * Determines if a color is considered "dark" (luminance < 0.5)
 */
export function isColorDark(hexColor: string): boolean {
    const rgb = hexToRgb(hexColor);
    if (!rgb) return false;

    const luminance = getLuminance(rgb.r, rgb.g, rgb.b);
    return luminance < 0.5;
}

/**
 * Returns the appropriate status bar style based on background color
 */
export function getStatusBarStyle(backgroundColor: string): 'light' | 'dark' {
    return isColorDark(backgroundColor) ? 'light' : 'dark';
}
